/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { selectIsCEUser } from "../../features/azure-b2c/storage";
import { TestIds } from "../../testIds";
import { HOME_ROUTE } from "../../util/routing";
import useMsalFunctions from "../../util/useMsalAuthFunctions";
import { Loader } from "../Loader";

const LogoutCEUser: React.FC = () => {
  const { handleCEMsalLogout } = useMsalFunctions();
  const isCEUser = useSelector(selectIsCEUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (isCEUser) {
      handleCEMsalLogout();
    } else {
      navigate(HOME_ROUTE, { replace: true });
    }
  }, []);

  return <Loader title="Logout" data-testid={TestIds.feat.logoutCE.loader} />;
};

export default LogoutCEUser;
